import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";
import { FieldDisplayRendererProps } from "./types";

export const ColorDisplayRenderer = ({
  field,
  value,
}: FieldDisplayRendererProps) => {
  return (
    <View style={[styles.colorBox, { backgroundColor: value }]}>
      <Text>{field.label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  colorBox: {
    width: 50,
    height: 50,
    marginVertical: 8,
  },
});
